import React, {useMemo} from 'react';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {type ReactAction} from '@netx/core/bootstrap';
import {ActionListItem, type ActionListItemProps} from './ActionListItem';
import {Divider} from '@mui/material';

export interface ActionListProps extends Pick<
	ActionListItemProps,
	'size' | 'slotProps'
> {
	actions: Array<ReactAction | ReactAction[]>;
	disabled?: boolean;
	loading?: boolean;
	onAction?: (action: ReactAction) => void;
}

export const renderActions = ({
	actions,
	disabled,
	loading,
	onAction,
	size,
	slotProps,
}: ActionListProps) => {
	const _actions = useMemo(() => actions.flat(), [actions]);

	const renderAction = useConstCallback((action: ReactAction) => {
		return (
			<ActionListItem
				key={`action-menu-item-${action.name}`}
				action={action}
				disabled={disabled}
				loading={loading}
				onAction={onAction}
				size={size}
				slotProps={slotProps}
			/>
		);
	});

	let lastGroup = 0;
	return _actions.map((action) => {
		const group = action.group ?? 0;
		const renderedAction = renderAction(action);
		if (group !== lastGroup) {
			lastGroup = group;
			return (
				<React.Fragment key={`action-group-${group}`}>
					{group > 0 && <Divider variant="middle" orientation="vertical" />}
					{renderedAction}
				</React.Fragment>
			);
		}
		return renderedAction;
	});
};

export const ActionList = (props: ActionListProps) => {
	return <>{renderActions(props)}</>;
};

export default ActionList;
